// extracted by mini-css-extract-plugin
export default {"postsContainerOuter":"cuMMdkdds","post":"cp8I9_PTP","container":"cOKfKSCra","whiteBoxInner":"cvYlyIw4U","stepImg":"cxzcTgONd"};